import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestFormPage.QBooksSalesInvoiceForm.SalesInvoiceMessagesSection', {
    customerMemoTitle: 'Message on invoice',
    customerMemoPlaceholder: 'Enter your message to ...',
    memoTitle: 'Message on statement',
    memoPlaceholder: 'It you send statements to customers, this will show up as the description for this invoice…',
});
